import { Field, TextInput, TextArea } from "@/components/setup/SetupField";

export const StepBrand = ({ form, update, errors }) => (
  <div className="space-y-6" data-testid="setup-step-brand">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      <Field label="Default menu language" required error={errors.default_language} testId="setup-field-default-language">
        <TextInput
          value={form.default_language}
          error={errors.default_language}
          onChange={(e) => update({ default_language: e.target.value })}
          placeholder="e.g. German"
          data-testid="setup-input-default-language"
        />
      </Field>
      <Field label="Currency" required error={errors.currency} testId="setup-field-currency">
        <TextInput
          value={form.currency}
          error={errors.currency}
          onChange={(e) => update({ currency: e.target.value })}
          placeholder="e.g. EUR"
          data-testid="setup-input-currency"
        />
      </Field>
    </div>

    <Field
      label="Additional menu languages"
      hint="Comma separated — e.g. English, Italian, French"
      testId="setup-field-additional-languages"
    >
      <TextInput
        value={form.additional_languages}
        onChange={(e) => update({ additional_languages: e.target.value })}
        placeholder="English, Italian"
        data-testid="setup-input-additional-languages"
      />
    </Field>

    <Field
      label="Primary brand color"
      hint="Optional — main accent color used on your local materials"
      testId="setup-field-brand-color"
    >
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={/^#[0-9a-fA-F]{6}$/.test(form.brand_color) ? form.brand_color : "#dd260e"}
          onChange={(e) => update({ brand_color: e.target.value })}
          className="w-10 h-10 border border-[#e8e8e8] rounded-sm cursor-pointer bg-white p-1"
          data-testid="setup-input-brand-color-picker"
        />
        <TextInput
          value={form.brand_color}
          onChange={(e) => update({ brand_color: e.target.value })}
          placeholder="#dd260e"
          data-testid="setup-input-brand-color"
        />
      </div>
    </Field>

    <Field
      label="Brand guideline notes"
      hint="Optional — anything we should know about local brand rules (fonts, co-branding, legal lines…)"
      testId="setup-field-brand-notes"
    >
      <TextArea
        value={form.brand_notes}
        onChange={(e) => update({ brand_notes: e.target.value })}
        placeholder="Optional"
        data-testid="setup-input-brand-notes"
      />
    </Field>
  </div>
);
